import React, { useState, useEffect } from "react";
import TableComponent from "../../../components/Table/reactTable";
import { axInstBasic } from "../../../components/Service/Service";

const registrationColumns = [
  { accessorKey: "Chassis", header: "Chassis No" },
  { accessorKey: "RegNo", header: "Reg. No" },
  { accessorKey: "RegDate", header: "Reg. Date" },
  { accessorKey: "RegAt", header: "Reg. At" },
  { accessorKey: "Permit", header: "Permit No" },
  { accessorKey: "PermitType", header: "Permit Type" },
  { accessorKey: "FromDate", header: "From Date" },
  { accessorKey: "ToDate", header: "To Date" },
];

export default function RegistrationDetails({ isArn }) {
  const [registrationData, setRegistrationData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!isArn) return; // Wait until ARN is available

    const fetchData = async () => {
      setLoading(true);
      setError(null);

      try {
        // axInstBasic already includes:
        // - baseURL
        // - Basic Auth
        // - withCredentials (for cookie token)
        const response = await axInstBasic.post("tableData", { isArn });

        const resultArray = response?.data?.result || [];

        if (resultArray.length) {
          const transformed = resultArray.map((item) => {
            const fields = item.fields || {};
            return {
              Chassis: fields.X_ASSET_NUM?.[0] ?? "N/A",
              RegNo: fields.X_LCNS_NUM?.[0] ?? "N/A",
              RegDate: fields.X_REGISTERED_DT?.[0]?.split("T")[0] ?? "N/A",
              RegAt: fields.X_REG_AT?.[0] ?? "N/A",
              Permit: fields.X_PERMIT_NO?.[0] ?? "N/A",
              PermitType: fields.X_PERMIT_TYPE?.[0] ?? "N/A",
              FromDate: fields.X_PERMIT_FROM?.[0]?.split("T")[0] ?? "N/A",
              ToDate: fields.X_INS_TO?.[0]?.split("T")[0] ?? "N/A",
            };
          });

          setRegistrationData(transformed);
        } else {
          setRegistrationData([]); // No data
        }
      } catch (err) {
        console.error("Error fetching registration data:", err);
        setError(err.message || "Failed to fetch registration details.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [isArn]); // re-fetch if ARN changes

  // 🌀 Loading state
  if (loading) {
    return <p className="text-center py-4 text-gray-600">Loading...</p>;
  }

  // ❌ Error state
  if (error) {
    return <p className="text-center py-4 text-red-500">Error: {error}</p>;
  }

  // ⚠️ No data state
  if (!registrationData.length) {
    return (
      <p className="text-center py-4 text-gray-500">
        No registration data available.
      </p>
    );
  }

  // ✅ Render table
  return (
    <div className="p-2 relative">
      <TableComponent
        data={registrationData}
        columns={registrationColumns}
        tableKey="registrationTable"
        heading="Chassis Wise Registration and Permit Details"
      />
    </div>
  );
}

// import React, { useState, useEffect } from "react";
// import TableComponent from "../../../components/Table/reactTable";
// import { axInst, axInstBasic } from "../../../components/Service/Service";

// const registrationColumns = [
//   { accessorKey: "Chassis", header: "Chassis No" },
//   { accessorKey: "RegNo", header: "Reg. No" },
//   { accessorKey: "RegDate", header: "Reg. Date" },
//   { accessorKey: "RegAt", header: "Reg. At" },
//   { accessorKey: "Permit", header: "Permit No" },
//   { accessorKey: "PermitType", header: "Permit Type" },
//   { accessorKey: "FromDate", header: "From Date" },
//   { accessorKey: "ToDate", header: "To Date" },
// ];

// export default function RegistrationDetails({ isArn }) {
//   const [registrationData, setRegistrationData] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     if (!isArn) return; // wait until ARN is available

//     const fetchData = async () => {
//       setLoading(true);
//       setError(null);

//       const basicAuth =
//         "Basic " +
//         btoa(`${process.env.REACT_APP_UNAME}:${process.env.REACT_APP_PWD}`);

//       try {
//         const response = await axInstBasic.post(
//           `${process.env.REACT_APP_API_URL}tableData`,
//           { isArn },
//           {
//             headers: {
//               Authorization: basicAuth,
//               "Content-Type": "application/json",
//             },
//           }
//         );

//         const rawResponse = response.data;
//         const resultArray = rawResponse?.result || [];

//         if (resultArray.length) {
//           const transformedData = resultArray.map((item) => {
//             const fields = item.fields || {};
//             return {
//               Chassis: fields.X_ASSET_NUM?.[0] ?? "N/A",
//               RegNo: fields.X_LCNS_NUM?.[0] ?? "N/A",
//               RegDate: fields.X_REGISTERED_DT?.[0]?.split("T")[0] ?? "N/A",
//               RegAt: fields.X_REG_AT?.[0] ?? "N/A",
//               Permit: fields.X_PERMIT_NO?.[0] ?? "N/A",
//               PermitType: fields.X_PERMIT_TYPE?.[0] ?? "N/A",
//               FromDate: fields.X_PERMIT_FROM?.[0]?.split("T")[0] ?? "N/A",
//               ToDate: fields.X_INS_TO?.[0]?.split("T")[0] ?? "N/A",
//             };
//           });

//           setRegistrationData(transformedData);
//         } else {
//           setRegistrationData([]); // handle empty dataset
//         }
//       } catch (err) {
//         console.error("Error fetching data:", err);
//         setError(err.message || "An unknown error occurred while fetching data.");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, [isArn]); // re-run when ARN changes

//   // 🌀 Loading state
//   if (loading) {
//     return <p className="text-center py-4 text-gray-600">Loading...</p>;
//   }

//   // ❌ Error state
//   if (error) {
//     return <p className="text-center py-4 text-red-500">Error: {error}</p>;
//   }

//   // ⚠️ Empty data
//   if (!registrationData.length) {
//     return <p className="text-center py-4 text-gray-500">No registration data available.</p>;
//   }

//   // ✅ Render table
//   return (
//     <div className="p-2 relative">
//       <TableComponent
//         data={registrationData}
//         columns={registrationColumns}
//         tableKey="registrationTable"
//         heading="Chassis Wise Registration and Permit Details"
//       />
//     </div>
//   );
// }
